"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecondaryPopupButtons = void 0;

var _react = _interopRequireDefault(require("react"));

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _propTypes = require("prop-types");

var _loadStyles = _interopRequireDefault(require("load-styles"));

(0, _loadStyles.default)(".c77a48de8{display:grid;grid-template-columns:repeat(auto-fit,minmax(0,-webkit-max-content));grid-template-columns:repeat(auto-fit,minmax(0,max-content));grid-gap:.5rem;grid-gap:.5rem;gap:.5rem;grid-gap:.5rem;justify-content:end;background:var(--color-gray-10);box-shadow:0 -1px 0 var(--color-gray-20);padding:1rem 1.25rem;flex-grow:0;flex-shrink:0}");
var styles = {
  root: 'c77a48de8'
};

var SecondaryPopupButtons = function SecondaryPopupButtons(props) {
  var classes = props.classes,
      children = props.children;
  var cn = (0, _useStyles.useStyles)(styles, classes);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: cn.root
  }, children);
};

exports.SecondaryPopupButtons = SecondaryPopupButtons;
SecondaryPopupButtons.propTypes = {
  /* component logic props */
  children: _propTypes.node.isRequired,

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
SecondaryPopupButtons.defaultProps = {
  classes: {}
};